import { Box, Link } from '@podiumhq/design-system';
import {
  PODIUM_PRIVACY_POLICY_URL,
  PODIUM_TERMS_AND_CONDITIONS_URL,
} from 'routes/constants';

const DEFAULT_DISCLAIMER_TEXT =
  'By entering your email you agree to receive marketing text and emails from Podium. By clicking “Start free trial”, you agree that you have read and accept the Podium';

export const TrialDisclaimer = ({
  color = 'grey.light',
  disclaimerText = DEFAULT_DISCLAIMER_TEXT,
  fontSize = '12px',
  linkProps = {},
  ...props
}) => {
  const linkCommonProps = {
    target: '_blank',
    textDecoration: 'underline',
    ...linkProps,
  };

  return (
    <Box color={color} fontSize={fontSize} lineHeight="150%" {...props}>
      {`${disclaimerText} `}
      <Link
        href={PODIUM_TERMS_AND_CONDITIONS_URL}
        {...linkCommonProps}
        data-e2e="terms-of-service-link"
      >
        Terms of Service
      </Link>
      {' and '}
      <Link
        href={PODIUM_PRIVACY_POLICY_URL}
        {...linkCommonProps}
        data-e2e="privacy-policy-link"
      >
        Privacy Policy
      </Link>
      .
    </Box>
  );
};
